module.exports = __webpack_public_path__ + "img/12.154d7398.png";